import { isBrowser } from '@websolutespa/bom-core';
import { useEffect, useLayoutEffect } from 'react';

export const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
